<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="searchBox">
            <div class="searchGroup">
                <label>收入\支出：</label>
                <el-select v-model="search_Obj.f_income_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('income_state')" :key="'income_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>收入方式：</label>
                <el-select v-model="search_Obj.f_income_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('income_type')" :key="'income_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <el-button type="primary" plain @click.native="add">加/减积分</el-button>
            <el-button type="primary" plain @click.native="add1">加/减会员天数</el-button>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="email" label="邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="income_state" label="收入\支出" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.income_state, "income_state") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="income_type" label="收入\支出方式" sortable="custom" width="160">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.income_type, "income_type") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="point" label="积分" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="remark" label="备注" sortable="custom"></el-table-column>
                <el-table-column prop="add_time" label="时间" sortable="custom" width="170"></el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :member_id="search_Obj.f_member_id"
            title="加/减积分"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Edit1
            width="600px"
            :id="model_id"
            :member_id="search_Obj.f_member_id"
            title="加/减会员天数"
            :isshow="editshow1"
            @on-close="closeEditDialog1">
        </Edit1>
    </el-dialog>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Edit1 from "./edit1"
import listutil from "@/libs/listutil"

export default {
    name: 'memberPointLogList',
    mixins: [listutil],
    components: {Edit, Edit1, Btns, LabBtns},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        member_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.search_Obj.f_member_id = this.member_id
                this.getData();
            }
        }
    },
    data() {
        return {
            showflag: false,
            m_name: '积分日志',
            menu_id: 9999,
            list_url: "/api/admin/memberpointlog/list",
            search_Obj: {
                f_member_id: '',
                f_income_state: '',
                f_income_type: '',
            },
            del_Obj:{
                url:'/api/admin/memberpointlog/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['income_state', 'income_type'],
            editshow1: false,
        };
    },
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
        add1() {
            this.model_id = -1
            this.editshow1 = true
        },
        closeEditDialog1() {
            this.editshow1 = false
        },
    }
};
</script>